import * as React from 'react'
import ActivitiesLogo from '../../assets/img/activities-logo.svg'
import backgroundImg from '../../assets/img/gradient-shape.svg'
import Logo from '../../assets/img/logo.svg'
import './style.scss'

import { GetNumberWindow } from 'components'
import Swiper from 'react-id-swiper'
import 'react-phone-input-2/lib/style.css'
import { _route } from 'routes/config'

interface IProps {
  onClose: () => void
  parentId: string
  havePhoneNumber: any
  isUserForwardFromHeader: boolean
  goToAbilities: () => void
}

export const ActivitiesComponent: React.FC<IProps> = ({
  parentId,
  onClose,
  havePhoneNumber,
  isUserForwardFromHeader,
  goToAbilities
}: IProps) => {
  const [isTryForFreeClicked, setIsTryForFreeClicked] = React.useState(false)

  const demoLink =
    'https://www.figma.com/proto/P5uGok5W6pl59cl1uXXms9sa/New-Parent-Interface?node-id=8306%3A12874&viewport=1861%2C469%2C0.09978259354829788&scaling=contain&hotspot-hints=0'

  const onExplanationSubmit = () => {
    if (havePhoneNumber) {
      if (isUserForwardFromHeader) {
        onClose()
      }
      window.open(demoLink, '_blank')
      if (!isUserForwardFromHeader) {
        goToAbilities()
      }
    } else {
      setIsTryForFreeClicked(true)
    }
  }

  const renderTabs = () => {
    const params = {
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    }
    return (
      <Swiper {...params}>
        <div>
          <div className="tab">
            <div className="title extra-bold">How it works</div>
            <div className="text">
              GiantLeap provides you with short courses consisting of daily{' '}
              <span className="bold">parent-and-child activities</span> based on
              your child’s evaluation results
            </div>
            <button
              className="explanation-submit-btn"
              onClick={() => {
                onExplanationSubmit()
              }}
            >
              Try for free
            </button>
          </div>
        </div>
        <div>
          <div className="tab">
            <div className="title extra-bold">How it works</div>
            <div className="text">
              Activities take under 15 minutes a day to complete, and are
              designed to{' '}
              <span className="bold">
                develop healthy habits, behavior patterns, and life-skills
              </span>
            </div>
            <button
              className="explanation-submit-btn"
              onClick={() => {
                onExplanationSubmit()
              }}
            >
              Try for free
            </button>
          </div>
        </div>
        <div>
          <div className="tab">
            <div className="title extra-bold">How it works</div>
            <div className="text">
              The activities are as much for you as they are for your child.{' '}
              <span className="bold">Practice makes perfect </span>and it’s up
              to you to lead by example
            </div>
            <button
              className="explanation-submit-btn"
              onClick={() => {
                onExplanationSubmit()
              }}
            >
              Try for free
            </button>
          </div>
        </div>
      </Swiper>
    )
  }

  const renderActivitiesExplanationWindow = () => {
    return (
      <div>
        <div className="activities-logo">
          <img src={ActivitiesLogo} />
          <span className="activities-logo-text">BETA</span>
        </div>
        {renderTabs()}
        <img src={backgroundImg} className="background-shape" />
        <div className="pc-background-shape" />
      </div>
    )
  }

  return (
    <div className="activities-container">
      <img src={Logo} className="logo-size" />
      <div className="company-name light-font-weight">
        <span className="extra-bold">Giant</span>
        Leap
      </div>

      {isTryForFreeClicked && (
        <GetNumberWindow
          parentId={parentId}
          goToAbilities={goToAbilities}
          isUserForwardFromHeader={isUserForwardFromHeader}
          onClose={onClose}
          demoLink={demoLink}
        />
      )}
      {!isTryForFreeClicked && renderActivitiesExplanationWindow()}
    </div>
  )
}
export default ActivitiesComponent



// WEBPACK FOOTER //
// ./src/components/ActivitiesComponent/index.tsx